module.exports = __webpack_public_path__ + "static/sydair-logo-133bf1a08d0bb256c74e8e0d1c7e22fd.png";